import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Sparkles, ExternalLink } from 'lucide-react';

const WALKTHROUGH_URL = 'https://app.guidde.com/share/playbooks/eFSFop2spwJSPauzwuHNn3?origin=UtISP7ThlQcLHePJybYVN9Cs9Ek1&t=0&mode=videoOnly';

export default function WelcomeMessage({ open, onClose, loginCount }) {
  const handleWatchWalkthrough = () => {
    window.open(WALKTHROUGH_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="welcome-message">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-md bg-primary/10 flex items-center justify-center shrink-0">
              <Sparkles className="h-5 w-5 text-primary" />
            </div>
            <DialogTitle className="font-['Outfit'] text-lg leading-tight">
              Welcome to TheMoneyMap!
            </DialogTitle>
          </div>
        </DialogHeader>
        
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground leading-relaxed">
            Get started with our comprehensive video walkthrough to learn how to make the most of TheMoneyMap. 
            This guide will show you how to track your income, expenses, net worth, and more.
          </p>

          <div className="p-3 rounded-md border border-border bg-muted/30">
            <p className="text-xs text-muted-foreground">
              <strong className="text-foreground">Tip:</strong> You can always access this walkthrough from the About page.
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between gap-2 mt-2">
          <Button variant="ghost" size="sm" onClick={onClose} data-testid="welcome-skip">
            Skip for now
          </Button>
          <Button size="sm" onClick={handleWatchWalkthrough} data-testid="welcome-watch">
            Watch Walkthrough
            <ExternalLink className="h-3.5 w-3.5 ml-1" />
          </Button>
        </div>

        {loginCount && loginCount <= 3 && (
          <p className="text-center text-[11px] text-muted-foreground">
            Login {loginCount} of 3
          </p>
        )}
      </DialogContent>
    </Dialog>
  );
}
